var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white md__card--holder" }, [
    _c("div", { staticClass: "card border-0" }, [
      _c(
        "div",
        {
          staticClass:
            "card-header bg-navy rounded-0 navbar-height d-flex align-items-center",
        },
        [
          _c("div", {
            staticClass: "task-title h4 mb-0",
            attrs: { contenteditable: _vm.canEdit },
            domProps: { innerHTML: _vm._s(_vm.editTitle) },
            on: {
              keypress: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.onTitleChanged($event)
              },
              blur: function ($event) {
                return _vm.onTitleChanged($event)
              },
              focus: _vm._onTitleFocusClicked,
            },
          }),
        ]
      ),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "form",
          { staticClass: "hideBlockParent" },
          [
            _c("UserPickerProject", {
              attrs: { multi: false, title: "Project Owner", role: "OWNER" },
              on: {
                userSelected: _vm.handleSubmit,
                userRemoved: _vm.handleSubmit,
              },
              model: {
                value: _vm.project.user_owner,
                callback: function ($$v) {
                  _vm.$set(_vm.project, "user_owner", $$v)
                },
                expression: "project.user_owner",
              },
            }),
            _c("div", { staticClass: "row mt-4" }, [
              _c(
                "div",
                { class: { "col-md-12": !_vm.editId, "col-md-6": _vm.editId } },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-block",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(_vm._s(_vm.editId ? "Update" : "Create"))]
                  ),
                ],
                1
              ),
              _vm.editId
                ? _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-block",
                          attrs: { type: "danger" },
                          on: { click: _vm._onArchiveClicked },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.project.is_archieved ? "UnArchive" : "Archive"
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }